import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantUnemploymentTypePage = {
  alert: {
    error: 'coapplicant-unemployment-type-page.form.alert.error',
  },
  footer: {
    root: 'coapplicant-unemployment-type-page.footer.root',
  },
  form: {
    h1: 'coapplicant-unemployment-type-page.form.h1',
    h2: 'coapplicant-unemployment-type-page.form.h2',
    radioGroupRoot: 'coapplicant-unemployment-type-page.form.radio-group-root',
    radioOption1: 'coapplicant-unemployment-type-page.form.radio-option1',
    radioOption2: 'coapplicant-unemployment-type-page.form.radio-option2',
    radioOption3: 'coapplicant-unemployment-type-page.form.radio-option3',
    radioOption4: 'coapplicant-unemployment-type-page.form.radio-option4',
    radioOption5: 'coapplicant-unemployment-type-page.form.radio-option5',
    root: 'coapplicant-unemployment-type-page.form.root',
    submitButton: 'coapplicant-unemployment-type-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
